import ErrorOutlined from "@mui/icons-material/ErrorOutlined";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { tokens } from "~/locales/tokens";
import { useStore } from "~/store";
import { Dialog } from "~served/ui-comps/components/dialog";

export const RoomMasterErrorDialog = () => {
	const { t } = useTranslation();
	const roomMasterError = useStore((store) => store.roomMasterError);
	const setRoomMasterError = useStore((store) => store.setRoomMasterError);

	if (!roomMasterError) return null;

	return (
		<Dialog
			dialogProps={{ maxWidth: "xs" }}
			content={
				<Stack
					gap={2}
					alignItems="center">
					<ErrorOutlined
						sx={{ fontSize: "60px", color: (t) => t.palette.primary.main }}
					/>
					<Typography
						variant="body1"
						fontWeight="600">
						Room Master error
					</Typography>
					<Typography variant="body2">{roomMasterError}</Typography>
				</Stack>
			}
			actionButtonProps={{
				children: t(tokens.global.close),
				onClick: () => setRoomMasterError(null),
			}}
		/>
	);
};
